/* eslint-disable */

import { PAGE_URLS } from '../consts';

const { ont = {} } = window.utils;

/**
 * Accordion animation
 * @param {*} dom Collapsed Elements
 * @param {*} time Animation duration
 * @returns
 */
function transitionHeight(dom, time) {
  if (typeof window.getComputedStyle == 'undefined') {
    return;
  }

  const element = dom;
  // Get the height before folding
  const { height } = window.getComputedStyle(element);

  // Set height adaptation to obtain the height of element expansion
  element.style.transition = 'none';
  element.style.height = 'auto';

  const { height: targetHeight } = window.getComputedStyle(element);

  // Set the element height to the unexpanded height
  element.style.height = height;
  // Read element attributes to trigger browser redraw
  // eslint-disable-next-line no-unused-expressions
  element.offsetWidth;

  // Animate first and then set the height of the element expansion
  if (time) {
    element.style.transition = `all ${time}ms`;
  }
  element.style.height = targetHeight;
}

function isIOS() {
  return /(Mac|iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
}

function checkEmail(email) {
  const filter =
    /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,8}|[0-9]{1,3})(\]?)$/;
  return filter.test(email);
}

function isLogin() {
  return ont?.isLogin();
}

const isSafari =
  /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

/**
 * get url param
 * @param {string} url
 * @param {string} name
 * @return {string}
 */
function getUrlParam(name, url) {
  if (!name) {
    return '';
  }
  const pattern = url || window.location.search;
  const reg = new RegExp(`(?:[?&]|^)${name}=([^?&#]*)`, 'i');
  const match = pattern.match(reg);
  return !match ? '' : decodeURIComponent(match[1]);
}

/**
 * get url params
 * @param {string} url
 * @return {Object}
 */
function getUrlParams(url) {
  const pattern = url.replace(/#.*$/, '');
  const queryArray = pattern.split(/[?&]/).slice(1);
  let i;
  const args = {};
  for (i = 0; i < queryArray.length; i++) {
    const match = queryArray[i].match(/([^=]+)=([^=]+)/);
    if (match !== null) {
      args[match[1]] = decodeURIComponent(match[2]);
    }
  }
  return args;
}

function addYouTubeIframeAPI() {
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function isObject(obj) {
  return toString.call(obj) === '[object Object]';
}
function isArray(obj) {
  return toString.call(obj) === '[object Array]';
}

/**
 * 格式化timestamp
 * @param  timestamp
 * @param  {string} format    格式字符串, 如 yyyy-MM-dd, yyyy-MM-dd hh:mm:ss
 * @return {string}           格式化后的字符串
 */
function formatTimestamp(timestamp, format) {
  const inputDate = new Date(timestamp);
  let formatTpl = format;
  const date = {
    'M+': inputDate.getMonth() + 1,
    'd+': inputDate.getDate(),
    'h+': inputDate.getHours(),
    'm+': inputDate.getMinutes(),
    's+': inputDate.getSeconds(),
    'q+': Math.floor((inputDate.getMonth() + 3) / 3),
    'S+': inputDate.getMilliseconds(),
  };
  if (/(y+)/i.test(formatTpl)) {
    formatTpl = formatTpl.replace(
      RegExp.$1,
      inputDate
        .getFullYear()
        .toString()
        .substr(4 - RegExp.$1.length)
    );
  }
  for (const k in date) {
    if (new RegExp(`(${k})`).test(formatTpl)) {
      formatTpl = formatTpl.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? date[k]
          : `00${date[k]}`.substr(`${date[k]}`.length)
      );
    }
  }
  return formatTpl;
}

function deepCopy(obj) {
  try {
    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }
    const newObj = obj.constructor === Array ? [] : {};
    Object.keys(obj).forEach((key) => {
      newObj[key] = deepCopy(obj[key]);
    });
    return newObj;
  } catch (e) {
    console.log(e);
    return null;
  }
}

/**
 * 浅拷贝
 * @param obj
 */
function shallowCopy(obj) {
  const newobj = {};
  if (obj) {
    const keys = Object.keys(obj);
    keys.forEach((item) => {
      newobj[item] = obj[item];
    });
  }
  return newobj;
}

function deepMerge(target, other) {
  if (isObject(target) && isObject(other)) {
    for (let [key, val] of Object.entries(other)) {
      if (!target[key]) {
        target[key] = val;
      } else {
        target[key] =
          typeof val === 'object' ? deepMerge(target[key], val) : val;
      }
    }
  } else if (isArray(target) && isArray(other)) {
    for (let [key, val] of Object.entries(other)) {
      if (target[key]) {
        target[key] =
          typeof val === 'object' ? deepMerge(target[key], val) : val;
      } else {
        target.push(val);
      }
    }
  }
  return target;
}

function isNumber(str) {
  return typeof str === 'string' && /^-?\d+\.?\d*$/.test(str);
}

function getLoginUrl() {
  const { pathname, search, hash } = window.location;
  const forwardUrl = `${pathname}${search}${hash}`;
  const loginUrl = `${PAGE_URLS.login}${encodeURIComponent(forwardUrl)}`;
  return loginUrl;
}

const isNotEmpty = (value) => {
  return (
    String(value) !== 'NaN' && String(value) !== 'undefined' && value !== ''
  );
};

const getBlogImg = (obj) => {
  let url = '';
  try {
    url = obj['_embedded']['wp:featuredmedia'][0].source_url;
  } catch (e) {
    url = '';
  }

  return url;
};

export default {
  isIOS,
  isLogin,
  isSafari,
  isObject,
  isArray,
  isNumber,
  isNotEmpty,
  deepCopy,
  deepMerge,
  shallowCopy,
  checkEmail,
  getUrlParam,
  getUrlParams,
  formatTimestamp,
  transitionHeight,
  addYouTubeIframeAPI,
  getLoginUrl,
  getBlogImg,
};
